import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclDrawerService,
    CclNavbarFooterService,
    CclMessageService, 
    CclRouteTab, 
    CclNotifyService, 
    CclListColumn, 
    CclList, 
    CclListColumnSize, 
    CclTemplateResolverService,
    CclListTemplateProviderComponent,
    CclListTemplates
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";
import { SessionService } from "../../../../../modules/shared/services/session-service";
import { DatePipe } from "@angular/common";
import * as moment from 'moment';

@Component({
    selector: "app-filter-page",
    templateUrl: "./filter-page.view.html",
    styleUrls: []
})
export class FilterPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    subscription: Subscription;
    filterSetup: any;
    filterSetupObj: any = {};
    standardFieldLabels: any = {};
    customFieldLabels: any = {};
    headerStyle: any = {};
    bodyStyle: any = {};
    labelJSON: any = null;
    tabConfigObj:any = {};
    selectedTab = 'filter';
 	columns: CclListColumn[];
 	filters: CclList = <CclList>{ data: {}, pagination: {}};
 	noFilters: Boolean = true;
    datePipe = new DatePipe("en-US");
    index: any;

    constructor(
        public sharedService: SharedService,
        private drawerService: CclDrawerService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private localDataService: LocalDataService,
        private sessionService: SessionService,
        private notifyService: CclNotifyService,
        private templateResolver: CclTemplateResolverService
    ) {
        super(sharedService);
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveFilterConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.sharedService.currentLayoutSection = "filter";
        this.getJSON();
        this.filterSetupObj = this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG];
        this.tabConfigObj = this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG];
        if (this.filterSetupObj == null || this.filterSetupObj.id == null) {
            this.filterSetup = cloneDeep(this.sharedService.filterSetup);
            this.filterSetupObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.FILTER_CONFIG
            };
        } else {
            this.filterSetup = JSON.parse(this.filterSetupObj.config);
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.filterSetup);
        this.sharedService.changedData = this.filterSetup;

        this.localDataService.getJSON("filter-standardFields.json").subscribe((data) => {
            if (data != null) {
                data.forEach((element) => {
                    this.standardFieldLabels[element.code] = element.label;
                });
            }
        });
        this.sharedService.sessionEnumCustomFields.forEach((element) => {
            this.customFieldLabels["customField_" + element.id] = element.name;
        });

        this.headerStyle = {
            "background-color": this.filterSetup.header.backgroundColor,
            "font-style": this.filterSetup.header.fontStyle,
            "text-decoration": this.filterSetup.header.fontStyle,
            "font-weight": this.filterSetup.header.fontStyle,
            "font-size": this.filterSetup.header.fontSize + "px",
            color: this.filterSetup.header.fontColor
        };

        this.bodyStyle = {
            "background-color": this.filterSetup.body.backgroundColor,
            "font-style": this.filterSetup.body.fontStyle,
            "text-decoration": this.filterSetup.body.fontStyle,
            "font-weight": this.filterSetup.body.fontStyle,
            "font-size": this.filterSetup.body.fontSize + "px",
            color: this.filterSetup.body.fontColor
        };

        this.getSessionTracks();
        this.getSessionLevels();
        this.getSessionTypes();
        this.getLocations();
        this.getTags();
        this.getIndustries();
        this.getJobFunctions();
        this.getProductGoals();

        this.sessionService.getSessionInstanceDates().subscribe((data) => {
            this.sharedService.sessionDays = [];
            this.sharedService.sessionTimes = [];
            data.body["timeList"].forEach((date) => {
                this.sharedService.sessionTimes.push({
                    id: date,
                    label: date
                });
            });
            data.body["dateList"].forEach((date) => {
                this.sharedService.sessionDays.push({
                    id: new Date(date),
                    label: new Date(date)
                });
            });
        });

        this.getFilterPresetOptions();
    }

    getFilterPresetOptions() {
        this.catalogService.getFilterPresetOptions().subscribe((resp) => {
        let temp = {
            data: resp['body']
        }
        this.filters = <CclList>temp;
        this.filters.data.forEach((element:any) => {
            let tempDate = element.dateModified || element.dateCreated
            element.dateModified2 =  moment(new Date(tempDate)).fromNow();
            element.dateModified = this.datePipe.transform(tempDate, "MMMM dd, yyyy");
        })
        }, (err) => {
            // catch error here
        })
    }

    getSessionTracks() {
        this.sessionService.getSessionTracks().then((resp) => {
            this.sharedService.sessionTrack = resp.body['data'];
        })
    }

    getSessionLevels() {
        this.sessionService.getSessionLevels(this.sharedService.event.id).subscribe((resp) => {
            this.sharedService.sessionLevels = resp.body;
        })
    }

    getSessionTypes() {
        this.sessionService.getSessionTypes(this.sharedService.event.id).then((resp) => {
            this.sharedService.sessionTypes = resp.body;
        })
    }

    getLocations() {
        this.sessionService.getSessionLocations(this.sharedService.event.id).subscribe((resp) => {
            this.sharedService.sessionLocations = resp.body['data'];
        })
    }

    getTags() {
        this.sessionService.getSessiontags().subscribe(resp => {
            this.sharedService.sessionTags = resp.body['page'].content
        })
    }

    getIndustries() {
        this.sessionService.getIndustries(this.sharedService.account.code, this.sharedService.event.code).subscribe(resp => {
            this.sharedService.industries = resp.body['confIndustryDTOList']
        })
    }

    getJobFunctions() {
        this.sessionService.getJobFunctions(this.sharedService.account.code, this.sharedService.event.code).subscribe(resp => {
            this.sharedService.jobFunctions = resp.body['confJobFunctionDTOList']
        })
    }

    getProductGoals() {
        this.sessionService.getProductGoals(this.sharedService.account.id, this.sharedService.event.id).subscribe(resp => {
            this.sharedService.productGoals = resp.body['data'];
        })
    }

    getJSON() {
        let jsonPath =
            `/accounts/${this.sharedService.event.fileDir}session_catalog_${this.sharedService.catalogUUID}.json` +
            "?random=" +
            new Date().getTime();
        this.catalogService.getJSONService(jsonPath).subscribe((data)=> {
            this.labelJSON = data.body
        }, (err) => {
            this.getDefaultJSON();
        })
    }

    getDefaultJSON() {
        let jsonPath = './assets/i18n/en.json'
        this.catalogService.getJSONService(jsonPath).subscribe((data)=> {
            if(this.labelJSON == null) {
                this.labelJSON = data.body;
            }
        })
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (this.sharedService.catalogLayoutConfig.listType == "magazine") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Highlighted Session";
            } else if (this.sharedService.catalogLayoutConfig.listType == "promoted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Promoted Session";
            } else if (this.sharedService.catalogLayoutConfig.listType == "general") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define General Session";
            } else {
                this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Session Layout";
            }

            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-filter";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-filter";
        }

        const listTemplates = this.templateResolver.getTemplates(CclListTemplateProviderComponent, [
            CclListTemplates.icon,
            CclListTemplates.name,
            CclListTemplates.data,
            CclListTemplates.actionIcons
        ]);
        

        this.columns = [
            {
                label: "Filter Name",
                template: listTemplates[CclListTemplates.name],
                size: CclListColumnSize.full,
                key: "name",
                templateConfig: {
                    secondaryTitle: "Last Modified:",
                    secondaryData: "dateModified",
                    secondaryData2: "dateModified2"
                }
            },
            {
                label: "Actions",
                template: listTemplates[CclListTemplates.actionIcons],
                size: CclListColumnSize.xs,
                key: "",
                templateConfig: {
                    icons: [
                        {
                            class: "fa-link fa-rotate-90",
                            clickFn: this.clickCopyCatalogPreviewLink.bind(this),
                            title: "Copy Filter Link"
                        },
                        {
                            class: "fa-pencil fa-lg",
                            clickFn: this.editFilter.bind(this),
                            title: "Edit Filter"
                        },
                        {
                            class: "fa-times action-icon-danger",
                            clickFn: this.deleteFilter.bind(this),
                            title: "Delete Filter"
                        }
                    ]
                }
            }
        ];

        this.messageService.sendMessage("update-publish-button");
    }

    editFilter(e) {
        this.sharedService.currentDrawer = {
            title: "Save Filter",
            navLinks: null,
            saveMessage: "apply-save-filter-config"
        };
        this.drawerService.toggleDrawer("small");
        let url = "";
        this.index = this.filters.data.findIndex((item: any) => item.name == e.name);
        this.sharedService.isEditSaveFilter = true;
        this.sharedService.filterLabel = e.name;
        this.sharedService.preSetFilterOptions = JSON.parse(e.filterConfig);
        this.sharedService.editSaveFilter = e;
        this.sharedService.filterSetup = cloneDeep(this.filterSetup);
        url = "config-drawer/filter/save-filter";
        this.sharedService.navigateToOutlet("drawer", url);
    }

    async clickCopyCatalogPreviewLink(item) {
        if (item.isOnlyApplied) {
            return this._flashMessagesService.show("Please Save Filter first before copying", { cssClass: "alert-danger" });
        }

        //Remove PORTAL CUSTOMIZATION DEPENDENCY
        // let result:any = await this.catalogService.findCatalogRedirectToScalingCatalog({"catalogUUID": this.sharedService.catalogUUID}).toPromise();

        // let catalog_type_referrer = result.body.redirectTo ? "catalog/assets/attendee/" : "session_catalog/#/attendee/";
        let catalog_type_referrer = "catalog/assets/attendee/";
        
        let catalogUrl = window.location.protocol + "//" + window.location.hostname + "/" + 
            catalog_type_referrer + this.sharedService.catalogUUID + "/catalog?filterName=" + item.name;
        this.sharedService.copyText(catalogUrl);
        this._flashMessagesService.show("Catalog link copied.", { cssClass: "alert-success" });
    }

    deleteFilter (e) {
        const pnotify = this.notifyService.getPNotify();
        let temp = pnotify.alert({
            title: "Delete Filter",
            text: "Please confirm. Are you sure you want to delete the selected Filter?",
            addClass: "c-pnotify-confirm",
            hide: false,
            textTrusted: true,
            modules: {
                Confirm: {
                    confirm: true,
                    align: "flex-end",
                    buttons: [
                        {
                            text: "Ok",
                            textTrusted: false,
                            addClass: "",
                            primary: true,
                            promptTrigger: true,
                            click: (notice, value) => {
                                if(e.isOnlyApplied) {
                                    const index = this.filters.data.findIndex((item: any) => item.name == e.name);
                                    this.filters.data.splice(index, 1);
                                    notice.close();
                                    notice.fire("pnotify.confirm", { notice, value });
                                    return true;
                                }
                                this.catalogService.deleteFilter(e.id).subscribe((resp:any) => {
                                    notice.close();
                                    notice.fire("pnotify.confirm", { notice, value });
                                    this._flashMessagesService.show(resp.body.successApiResponse['message'], {
                                        cssClass: "alert-success"
                                    });
                                    this.getFilterPresetOptions();
                                }, (err) => {
                                    // catch error here
                                    notice.close();
                                    notice.fire("pnotify.confirm", { notice, value });
                                    this._flashMessagesService.show(err.body['message'], {
                                        cssClass: "alert-danger"
                                    });
                                })
                                return true;
                            }
                        },
                        {
                            text: "Cancel",
                            textTrusted: false,
                            addClass: "unsaved-btn--secondary",
                            primary: true,
                            promptTrigger: true,
                            click: (notice, value) => {
                                notice.close();
                                notice.fire("pnotify.cancel", { notice, value });
                                return false;
                            }
                        }
                    ]
                },
                Buttons: {
                    closer: false,
                    sticker: false
                }
            },
            stack: {
                modal: true
            }
        });
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveFilterConfig(message) {
        if (message.text == "save-filter" || message.text == "save-next-filter") {
            if(this.sharedService.filterSetup.selectTimezone) {
                this.filterSetup.selectTimezone = this.sharedService.filterSetup.selectTimezone;
            }
            if(this.filterSetup.isDefaultTimezone) {
                this.filterSetup.isDefaultTimezone = false;
            }
            if(this.sharedService.isCreateFilter) {
                let temp = { name: this.sharedService.filterLabel,
                    filterConfig: JSON.stringify(this.sharedService.preSetFilterOptions),
                    id: this.sharedService.editSaveFilter.id
                }
                this.catalogService.saveFilter(temp).subscribe((res) => {
                    this.sharedService.createSaveFilter = true;
                    this.sharedService.isCreateFilter = false;
                    this.sharedService.originalData["filterLabel"] = this.sharedService.filterLabel;
                    this.sharedService.originalData["preSetFilterOptions"] = this.sharedService.preSetFilterOptions;
                    this.sharedService.changedData["filterLabel"] = this.sharedService.filterLabel;
                    this.sharedService.changedData["preSetFilterOptions"] = this.sharedService.preSetFilterOptions;
                    this.getFilterPresetOptions();
                    this.messageService.sendMessage("update-publish-button");
                    this.sharedService.filterLabel = '';
                    this._flashMessagesService.show("Preset Filter saved successfully.", {
                        cssClass: "alert-success"
                    });
                }, (error) => {
                    this._flashMessagesService.show(error['error'].errorResponse['errors'][0], {
                        cssClass: "alert-danger"
                    });
                })
            } else {
                if (this.filterSetup.selectedDates) {
                    if (this.filterSetup.selectedDates.length == this.sharedService.dates.length || this.filterSetup.selectedDates.length == 0) {
                        delete this.filterSetup.selectedDates;
                    }
                }
                if(this.filterSetup.selectedIndustries) {
                    if ((this.filterSetup.selectedIndustries.length == this.sharedService.industries.length + 1) || this.filterSetup.selectedIndustries.length == 0) {
                        delete this.filterSetup.selectedIndustries;
                    }
                }
                if(this.filterSetup.selectedJobFunctions) {
                    if ((this.filterSetup.selectedJobFunctions.length == this.sharedService.jobFunctions.length + 1) || this.filterSetup.selectedJobFunctions.length == 0) {
                        delete this.filterSetup.selectedJobFunctions;
                    }
                }

                if(this.filterSetup.selectedProductGoals) {
                    if ((this.filterSetup.selectedProductGoals.length == this.sharedService.productGoals.length + 1) || this.filterSetup.selectedProductGoals.length == 0) {
                        delete this.filterSetup.selectedProductGoals;
                    }
                }

                if(this.filterSetup.selectedLevels) {
                    if ((this.filterSetup.selectedLevels.length == this.sharedService.sessionLevels.length + 1) || this.filterSetup.selectedLevels.length == 0) {
                        delete this.filterSetup.selectedLevels;
                    }
                }
                if(this.filterSetup.selectedLocations) {
                    if ((this.filterSetup.selectedLocations.length == this.sharedService.sessionLocations.length + 1) || this.filterSetup.selectedLocations.length == 0) {
                        delete this.filterSetup.selectedLocations;
                    }
                }
                if(this.filterSetup.selectedTags) {
                    if ((this.filterSetup.selectedTags.length == this.sharedService.sessionTags.length + 1) || this.filterSetup.selectedTags.length == 0) {
                        delete this.filterSetup.selectedTags;
                    }
                }
                if(this.filterSetup.selectedTimes) {
                    if (this.filterSetup.selectedTimes.length == this.sharedService.sessionTimes.length || this.filterSetup.selectedTimes.length == 0) {
                        delete this.filterSetup.selectedTimes;
                    }
                }
                if(this.filterSetup.selectedTracks) {
                    if ((this.filterSetup.selectedTracks.length == this.sharedService.sessionTrack.length + 1) || this.filterSetup.selectedTracks.length == 0) {
                        delete this.filterSetup.selectedTracks;
                    }
                }
                if(this.filterSetup.selectedTypes) {
                    if ((this.filterSetup.selectedTypes.length == this.sharedService.sessionTypes.length + 1) || this.filterSetup.selectedTypes.length == 0) {
                        delete this.filterSetup.selectedTypes;
                    }
                }
    
    
                if(this.filterSetup.standardFields.includes("sessionDateRange") && this.filterSetup.standardFields.includes("sessionDate")) {
                    this._flashMessagesService.show("Either Session Date or Session Date Range should be selected", {
                        cssClass: "alert-danger"
                    });
                    return
                }
    
                let tabConfig = JSON.parse(this.tabConfigObj.config)
                if(this.filterSetup.standardFields.includes("sessionDateRange") && tabConfig.isTabsEnabled) {
                    const pnotify = this.notifyService.getPNotify();
                    let temp = pnotify.alert({
                    title: "Alert",
                    text: "You have chosen to enable a date range filter. The Date tabs will be disabled. Please confirm to proceed.",
                    addClass: "c-pnotify-confirm",
                    hide: false,
                    textTrusted: true,
                    modules: {
                        Confirm: {
                            confirm: true,
                            align: "flex-end",
                            buttons: [
                                {
                                    text: "Ok",
                                    textTrusted: false,
                                    addClass: "",
                                    primary: true,
                                    promptTrigger: true,
                                    click: (notice, value) => {
                                        if(this.filterSetup.standardFields.includes("sessionDateRange")) {
                                            this.sharedService.tabConfig.isTabsEnabled = false;
                                            this.tabConfigObj.config = JSON.stringify(this.sharedService.tabConfig);
                                            this.catalogService.saveSetupConfig(this.tabConfigObj).subscribe((resp) => {        
                                            })
                                        }
    
                                        this.filterSetupObj.config = JSON.stringify(this.filterSetup);
                                        this.catalogService.saveSetupConfig(this.filterSetupObj).subscribe((resp) => {
                                            // For checking unsaved data
                                            this.sharedService.createCss(this.catalogService);
                                            this.sharedService.originalData = cloneDeep(this.filterSetup);
                                            this.sharedService.changedData = this.filterSetup;
    
                                            this.filterSetupObj = resp.body["sessionCatalogSetupConfigDTO"];
                                            this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] = this.filterSetupObj;
                                            this._flashMessagesService.show("Filter saved successfully.", {
                                                cssClass: "alert-success"
                                            });
                                            if (message.text == "save-next-filter") {
                                                if (this.sharedService.catalogLayoutConfig.listType == "magazine") {
                                                    this.sharedService.currentLayoutSection = "highlighted-session";
                                                    this.sharedService.catalogNavigateHelper("admin", "catalog/layout/highlighted-session");
                                                } else if (this.sharedService.catalogLayoutConfig.listType == "promoted") {
                                                    this.sharedService.currentLayoutSection = "promoted-session";
                                                    this.sharedService.catalogNavigateHelper("admin", "catalog/layout/promoted-session");
                                                } else if (this.sharedService.catalogLayoutConfig.listType == "general") {
                                                    this.sharedService.currentLayoutSection = "general-session";
                                                    this.sharedService.catalogNavigateHelper("admin", "catalog/layout/general-session");
                                                }
                                            }
                                            notice.close();
                                            notice.fire("pnotify.confirm", { notice, value });
                                        });
                                        return true;
                                    }
                                },
                                {
                                    text: "Cancel",
                                    textTrusted: false,
                                    addClass: "unsaved-btn--secondary",
                                    primary: true,
                                    promptTrigger: true,
                                    click: (notice, value) => {
                                        this.sharedService.publishInProgress = false;
                                        notice.close();
                                        notice.fire("pnotify.cancel", { notice, value });
                                        return false;
                                    }
                                }
                            ]
                        },
                        Buttons: {
                            closer: false,
                            sticker: false
                        }
                    },
                    stack: {
                        modal: true
                    }
                    });
                } else {
                    this.filterSetupObj.config = JSON.stringify(this.filterSetup);
                    this.catalogService.saveSetupConfig(this.filterSetupObj).subscribe((resp) => {
                        // For checking unsaved data
                        this.sharedService.createCss(this.catalogService);
                        this.sharedService.originalData = cloneDeep(this.filterSetup);
                        this.sharedService.changedData = this.filterSetup;
    
                        this.filterSetupObj = resp.body["sessionCatalogSetupConfigDTO"];
                        this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] = this.filterSetupObj;
                        this._flashMessagesService.show("Filter saved successfully.", {
                            cssClass: "alert-success"
                        });
                        if (message.text == "save-next-filter") {
                            if (this.sharedService.catalogLayoutConfig.listType == "magazine") {
                                this.sharedService.currentLayoutSection = "highlighted-session";
                                this.sharedService.catalogNavigateHelper("admin", "catalog/layout/highlighted-session");
                            } else if (this.sharedService.catalogLayoutConfig.listType == "promoted") {
                                this.sharedService.currentLayoutSection = "promoted-session";
                                this.sharedService.catalogNavigateHelper("admin", "catalog/layout/promoted-session");
                            } else if (this.sharedService.catalogLayoutConfig.listType == "general") {
                                this.sharedService.currentLayoutSection = "general-session";
                                this.sharedService.catalogNavigateHelper("admin", "catalog/layout/general-session");
                            }
                        }
                    });
                }
            }
            
        } else if (message.text == "apply-filter-config") {
            this.filterSetup = cloneDeep(this.sharedService.filterSetup);
            if(this.filterSetup.standardFields.includes("sessionDateRange") && this.filterSetup.standardFields.includes("sessionDate")) {
                this._flashMessagesService.show("Either Session Date or Session Date Range should be selected", {
                    cssClass: "alert-danger"
                });
                return
            }
            // For checking unsaved data
            this.sharedService.changedData = this.filterSetup;

            this.headerStyle = {};
            this.bodyStyle = {};
            setTimeout(() => {
                this.headerStyle = {
                    "background-color": this.filterSetup.header.backgroundColor,
                    "font-style": this.filterSetup.header.fontStyle,
                    "text-decoration": this.filterSetup.header.fontStyle,
                    "font-weight": this.filterSetup.header.fontStyle,
                    "font-size": this.filterSetup.header.fontSize + "px",
                    color: this.filterSetup.header.fontColor
                };
                this.bodyStyle = {
                    "background-color": this.filterSetup.body.backgroundColor,
                    "font-style": this.filterSetup.body.fontStyle,
                    "text-decoration": this.filterSetup.body.fontStyle,
                    "font-weight": this.filterSetup.body.fontStyle,
                    "font-size": this.filterSetup.body.fontSize + "px",
                    color: this.filterSetup.body.fontColor
                };
            }, 0);
            this.drawerService.hideDrawer();
            this.sharedService.isCreateFilter = false;
        } else if(message.text ==  'apply-save-filter-config') {
            if(!this.sharedService.filterLabel.trim()) {
                this._flashMessagesService.show('Filter Label is required', {
                    cssClass: "alert-danger"
                });
                return
            } 
            
            if(!(/^[a-zA-Z0-9_]*$/.test(this.sharedService.filterLabel.trim())) ) {
                this._flashMessagesService.show('Filter Label should only contain alphanumeric characters', {
                    cssClass: "alert-danger"
                }); 
                return
            }
                
            if(this.sharedService.preSetFilterOptions && Object.keys(this.sharedService.preSetFilterOptions).length == 0) {
                this._flashMessagesService.show('Filter Preset options is required', {
                    cssClass: "alert-danger"
                });
                return
            }

            if(!this.sharedService.isEditSaveFilter) {
                const index = this.filters.data.findIndex((item: any) => item.name == this.sharedService.filterLabel);
                if( index > -1) {
                    return this._flashMessagesService.show(`Filter with name '${this.sharedService.filterLabel}' already exist for this event.`, {
                        cssClass: "alert-danger"
                    });
                }
            }

            this.sharedService.changedData["filterLabel"] = this.sharedService.filterLabel;
            this.sharedService.changedData["preSetFilterOptions"] = this.sharedService.preSetFilterOptions;
            if('data' in this.filters === false) {
                this.filters = {
                    data: []
                }
            }

            let dateModified = this.datePipe.transform(new Date(), "MMMM dd, yyyy");
            if(this.sharedService.isEditSaveFilter && this.index > -1) {
                this.filters.data[this.index]["name"] = this.sharedService.filterLabel;
                this.filters.data[this.index]["filterConfig"] = JSON.stringify(this.sharedService.preSetFilterOptions);
                this.filters.data[this.index]["dateModified"] = dateModified;
                this.filters.data[this.index]["isOnlyApplied"] = true;
            } else {
                this.filters.data.push({name: this.sharedService.filterLabel, filterConfig: JSON.stringify(this.sharedService.preSetFilterOptions), dateModified, isOnlyApplied: true })
            }
            this.drawerService.hideDrawer();
            this.sharedService.isCreateFilter = true;
        }
    }

    toggleFilterEnable(e) {
        this.filterSetup.isFilterEnabled = !this.filterSetup.isFilterEnabled;
    }

    openConfigDrawer(item) {
        this.sharedService.currentDrawer = {
            title: "Edit Filter",
            navLinks: [
                new CclRouteTab("Configuration", "filter/config"),
                new CclRouteTab("Timezone Setting", "filter/timezone-setting"),
                new CclRouteTab("Customize display", "filter/customize-display")
            ],
            saveMessage: "apply-filter-config"
        };
        this.drawerService.toggleDrawer("small");
        let url = "";
        if (item == "filter") {
            this.sharedService.filterSetup = cloneDeep(this.filterSetup);
            url = "config-drawer/filter";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }

    selectTab(type) {
        this.selectedTab = type;
    }

    loadFilters($event) {
        let sortinKey = $event.sortProperty;
        let sortOrder = $event.sortDescending;
        if (sortinKey != null && sortinKey.length > 0) {
            this.filters.data.sort(function(a, b) {
                let valueA = a[sortinKey];
                let valueB = b[sortinKey];

                if (typeof valueA == "number") {
                    return sortOrder ? valueB - valueA : valueA - valueB;
                } else {
                    valueA = typeof valueA == 'boolean' ? valueA : valueA.toUpperCase();
                    valueB = typeof valueB == 'boolean' ? valueB : valueB.toUpperCase();
                }
                if (valueA < valueB) {
                    return sortOrder ? 1 : -1;
                }
                if (valueA > valueB) {
                    return sortOrder ? -1 : 1;
                }
                return 0;
            });
        }
    }

    openFilterDrawer(item) {
        this.sharedService.currentDrawer = {
            title: "Save Filter",
            navLinks: null,
            saveMessage: "apply-save-filter-config"
        };
        this.drawerService.toggleDrawer("small");
        let url = "";
        if (item == "saveFilter") {
            this.sharedService.filterLabel = '';
            this.sharedService.editSaveFilter = {};
            this.sharedService.isEditSaveFilter = false;
            this.sharedService.filterSetup = cloneDeep(this.filterSetup);
            url = "config-drawer/filter/save-filter";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
